/* Beatbot "dive" page kit: one-time reveals, stat count-up, depth explorer, jet diagram (plays only in view), click-to-load
   films, ledge depth tool, spec finder, lineup table position, sticky bar. Phones and tablets get static reveals and no
   auto-advance; everything respects prefers-reduced-motion. */
(function () {
  if (window.__bdKit) return;
  window.__bdKit = true;
  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var still = reduce || window.matchMedia("(max-width: 989px), (hover: none)").matches;
  if (still) document.documentElement.classList.add("bd-still");
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var io = "IntersectionObserver" in window;

  function initRise(root) {
    var els = $$("[data-bd-rise]", root);
    if (still || !io) { els.forEach(function (e) { e.classList.add("is-in"); }); return; }
    var o = new IntersectionObserver(function (en) {
      en.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add("is-in"); o.unobserve(e.target); } });
    }, { rootMargin: "0px 0px -8% 0px" });
    els.forEach(function (e) { o.observe(e); });
  }

  /* Stat count-up: runs once when the rail scrolls into view (desktop only) */
  function initCount(root) {
    if (still || !io) return;
    $$("[data-bd-count]", root).forEach(function (el) {
      var txt = el.textContent.trim(), end = parseFloat(txt.replace(/,/g, ""));
      if (isNaN(end)) return;
      var comma = txt.indexOf(",") > -1, dec = (txt.split(".")[1] || "").length;
      var fmt = function (v) { var s = v.toFixed(dec); return comma ? s.replace(/\B(?=(\d{3})+(?!\d))/g, ",") : s; };
      el.textContent = fmt(0);
      var o = new IntersectionObserver(function (en) {
        if (!en[0].isIntersecting) return;
        o.disconnect();
        var t0 = performance.now(), dur = 1100;
        (function step(t) {
          var k = Math.min(1, (t - t0) / dur), e = 1 - Math.pow(1 - k, 3);
          el.textContent = k < 1 ? fmt(end * e) : txt;
          if (k < 1) requestAnimationFrame(step);
        })(t0);
      }, { threshold: 0.4 });
      o.observe(el);
    });
  }

  /* Depth explorer: stops on a ruler, one photo panel at a time, a marker that travels down the ruler */
  function initDive(root) {
    $$("[data-bd-dive]", root).forEach(function (box) {
      var stops = $$("[data-bd-stop]", box), panels = $$("[data-bd-panel]", box), mark = $("[data-bd-mark]", box), rail = $("[data-bd-stops]", box);
      if (!stops.length) return;
      var i = 0, timer = null, touched = false;
      function place() { if (mark && rail) rail.style.setProperty("--bd-y", (stops[i].offsetTop + 14) + "px"); }
      function set(k, focus) {
        i = (k + stops.length) % stops.length;
        stops.forEach(function (s, n) { var on = n === i; s.classList.toggle("is-on", on); s.setAttribute("aria-selected", on ? "true" : "false"); s.tabIndex = on ? 0 : -1; });
        panels.forEach(function (p, n) { p.classList.toggle("is-on", n === i); });
        if (focus) stops[i].focus();
        place(); setTimeout(place, 520);
      }
      function stop() { touched = true; if (timer) { clearInterval(timer); timer = null; } }
      stops.forEach(function (s, n) {
        s.addEventListener("click", function () { stop(); set(n); });
        s.addEventListener("keydown", function (e) {
          if (e.key === "ArrowDown" || e.key === "ArrowRight") { e.preventDefault(); stop(); set(i + 1, true); }
          if (e.key === "ArrowUp" || e.key === "ArrowLeft") { e.preventDefault(); stop(); set(i - 1, true); }
        });
      });
      var prev = $("[data-bd-prev]", box), next = $("[data-bd-next]", box);
      if (prev) prev.addEventListener("click", function () { stop(); set(i - 1); });
      if (next) next.addEventListener("click", function () { stop(); set(i + 1); });
      set(0);
      window.addEventListener("resize", place);
      if (still || !io) return;
      new IntersectionObserver(function (en) {
        if (touched) return;
        if (en[0].isIntersecting && !timer) timer = setInterval(function () { set(i + 1); }, 5200);
        if (!en[0].isIntersecting && timer) { clearInterval(timer); timer = null; }
      }, { threshold: 0.35 }).observe(box);
      box.addEventListener("mouseenter", function () { if (timer) { clearInterval(timer); timer = null; } });
    });
  }

  /* Jet diagram: debris drifts toward the intake only while the figure is on screen */
  function initJet(root) {
    $$("[data-bd-jet]", root).forEach(function (el) {
      if (!io) { el.classList.add("is-live"); return; }
      new IntersectionObserver(function (en) { el.classList.toggle("is-live", en[0].isIntersecting); }, { threshold: 0.2 }).observe(el);
    });
  }

  /* Films: a thumbnail button swaps for the YouTube player on click; the hero film opens in a modal */
  function yt(id) {
    var f = document.createElement("iframe");
    f.src = "https://www.youtube-nocookie.com/embed/" + encodeURIComponent(id) + "?autoplay=1&rel=0";
    f.allow = "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture";
    f.allowFullscreen = true; f.title = "YouTube video player";
    return f;
  }
  var modal = null;
  function openFilm(id, from) {
    if (!modal) {
      modal = document.createElement("div");
      modal.className = "bd-modal"; modal.setAttribute("role", "dialog"); modal.setAttribute("aria-modal", "true"); modal.setAttribute("aria-label", "Video");
      modal.innerHTML = '<button type="button" class="bd-modal__x" aria-label="Close video">×</button><div class="bd-modal__box"></div>';
      document.body.appendChild(modal);
      var close = function () { modal.classList.remove("is-open"); $(".bd-modal__box", modal).innerHTML = ""; if (modal.__from) modal.__from.focus(); };
      modal.addEventListener("click", function (e) { if (e.target === modal || e.target.classList.contains("bd-modal__x")) close(); });
      document.addEventListener("keydown", function (e) { if (e.key === "Escape" && modal.classList.contains("is-open")) close(); });
    }
    modal.__from = from;
    $(".bd-modal__box", modal).appendChild(yt(id));
    modal.classList.add("is-open");
    $(".bd-modal__x", modal).focus();
  }
  function initFilms(root) {
    $$("[data-bd-film]", root).forEach(function (b) { b.addEventListener("click", function () { openFilm(b.getAttribute("data-bd-film"), b); }); });
    $$("[data-bd-yt]", root).forEach(function (b) {
      b.addEventListener("click", function () { var p = b.parentNode; p.appendChild(yt(b.getAttribute("data-bd-yt"))); p.removeChild(b); });
    });
  }

  /* Ledge tool: set the water depth on a ledge; models rated for deeper water only are marked */
  function initLedge(root) {
    $$("[data-bd-ledge]", root).forEach(function (box) {
      var r = $("input[type=range]", box), out = $("output", box), rows = $$("[data-min]", box);
      if (!r) return;
      function set() {
        var v = +r.value;
        if (out) out.innerHTML = v + "<small>in</small>";
        rows.forEach(function (row) {
          var min = parseFloat(row.getAttribute("data-min")), ok = v >= min, tag = $("[data-bd-ok]", row);
          row.classList.toggle("is-no", !ok);
          if (tag) tag.textContent = ok ? "Rated for it" : "Too shallow";
        });
      }
      r.addEventListener("input", set);
      set();
    });
  }

  /* Spec finder: type to keep matching rows; empty groups hide */
  function initSpecs(root) {
    $$("[data-bd-specs]", root).forEach(function (box) {
      var input = $("[data-bd-find]", box), none = $("[data-bd-none]", box), groups = $$("[data-bd-grp]", box);
      if (!input) return;
      input.addEventListener("input", function () {
        var q = input.value.trim().toLowerCase(), any = false;
        groups.forEach(function (g) {
          var shown = 0, head = ($(".bd-grp__t", g) || {}).textContent || "";
          var all = q && head.toLowerCase().indexOf(q) > -1;
          $$("[data-bd-spec]", g).forEach(function (s) {
            var hit = !q || all || s.textContent.toLowerCase().indexOf(q) > -1;
            s.hidden = !hit; if (hit) shown++;
          });
          g.hidden = !shown; if (shown) any = true;
        });
        if (none) none.hidden = any;
      });
    });
  }

  /* Lineup: bring the current model's column into view inside the table frame (never scrolls the page) */
  function initTable(root) {
    $$("[data-bd-table]", root).forEach(function (box) {
      var here = $("thead .is-here", box), first = $("thead th", box);
      if (!here || !first) return;
      var left = here.offsetLeft - first.offsetWidth - 12;
      if (left > 0 && box.scrollWidth > box.clientWidth) box.scrollLeft = left;
    });
  }

  function initSticky() {
    var bar = $("[data-bd-sticky]"); if (!bar) return;
    var form = document.querySelector('form[action*="/cart/add"]');
    var go = $("[data-bd-sticky-go]", bar);
    if (go) go.addEventListener("click", function () {
      if (form) { var b = form.querySelector("[type=submit],[name=add]"); if (b && !b.disabled) { b.click(); return; } }
      window.scrollTo({ top: 0, behavior: reduce ? "auto" : "smooth" });
    });
    if (!io || !form) return;
    new IntersectionObserver(function (en) { bar.classList.toggle("is-on", !en[0].isIntersecting && en[0].boundingClientRect.top < 0); }).observe(form);
  }

  function init(root) { initRise(root); initCount(root); initDive(root); initJet(root); initFilms(root); initLedge(root); initSpecs(root); initTable(root); }
  function boot() { init(document); initSticky(); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot); else boot();
  document.addEventListener("shopify:section:load", function (e) { init(e.target); });
})();
